<template>
  <div>
    <div v-if="!disabled">
      <div class="title-text">{{ $t('message.refuse.klarnaRebutDrawer.stepOneTitle') }}</div>
      <div class="title-text title-large">{{ $t('message.refuse.klarnaRebutDrawer.fillRebuttalTitle') }}</div>
      <div class="title-text">{{ $t('message.refuse.klarnaRebutDrawer.fillRebuttalDesc') }}</div>
    </div>

     <!-- 商品信息 -->
     <product-form :disabled="disabled" :class="disabled ? '' : 'card'" :data="formData.product" @update:data="formData.product = $event"></product-form>

    <!-- 交易详情 -->
    <transaction-details :disabled="disabled" class="card" :txn-info="txnInfo" :refund-list="refundList"></transaction-details>

    <!-- 客户信息 -->
    <customer-form :disabled="disabled" class="card" :data="formData.customer" @update:data="formData.customer = $event"></customer-form>

    <!-- 发货信息 -->
    <shipping-form :disabled="disabled" ref="shippingFormRef" class="card" :data="formData.shipping" @update:data="formData.shipping = $event"></shipping-form>

    <!-- 抗辩回复 -->
    <appeal-form :disabled="disabled" ref="appealFormRef" class="card" :data="formData" @update:data="formData = $event"></appeal-form>

  </div>
</template>

<script>
import { noDataString } from '@/const/const.js';
import AppealForm from '@/views/transaction/refuse-manage/klarna-rebut/components/form/appealForm/index.vue';
import CustomerForm from '@/views/transaction/refuse-manage/klarna-rebut/components/form/customerForm/index.vue';
import ProductForm from '@/views/transaction/refuse-manage/klarna-rebut/components/form/productForm/index.vue';
import ShippingForm from '@/views/transaction/refuse-manage/klarna-rebut/components/form/shippingForm/index.vue';
import TransactionDetails from '@/views/transaction/refuse-manage/klarna-rebut/components/form/transactionDetails/index.vue';
export default {
  components: {
    ProductForm,
    TransactionDetails,
    CustomerForm,
    ShippingForm,
    AppealForm,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
    // 交易信息
    txnInfo: {
      type: Object,
      default: () => {},
    },
    // 退款信息
    refundList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      noDataString,
    };
  },
  methods: {
    async validate() {
      return await this.$refs.shippingFormRef.validate() && await this.$refs.appealFormRef.validate();
    },
    clearValidate() {
      this.$refs.shippingFormRef.clearValidate();
      this.$refs.appealFormRef.clearValidate();
    },
  },
  computed: {
    formData: {
      get() {
        return this.data;
      },
      set(newValue) {
        this.$emit('update:data', newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

:deep(.el-input__count) {
  background-color: transparent !important;
  color: #8D98AF !important;
}

:deep(.el-descriptions__body) {
  background-color: transparent !important;
}

:deep(.el-table) {
  background-color: transparent !important;
}

:deep(.el-table__cell) {
  background-color: transparent !important;
}

.title-text {
  font-family: Open Sans, Open Sans;
  font-weight: 400;
  font-size: 16px;
  color: #667085;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 8px;
}

.title-large {
  font-weight: bold !important;
  font-size: 32px !important;
  color: #1A202C !important;
  line-height: 40px !important;
  }

.card {
  margin-top: 32px;
}

</style>
